const socialLinks = [
    {
        url: 'https://www.instagram.com/sinauinspecoes/',
        label: 'Instagram icon',
        icon: 'uil uil-instagram',
    },
    {
        url: "https://wa.me/558433147436",
        label: 'Whatsapp Icon',
        icon: 'uil uil-whatsapp',
    },
];

export default socialLinks;

